package com.appsyde.shared.modules.ticket.domain

class LockNotOwnedException(
    message: String? = "Lock not owned or expired",
    cause: Throwable? = null
) : Exception(message, cause)
